<template>
  <div class="k_main">
    <searchC></searchC>
    <div class="content">
      <div class="topadcs">
        <img :src="kimg" v-if="kimg" title="世界知名焊接设备首选供应商" alt="世界知名焊接设备首选供应商" />
      </div>
      <div class="rightl">
        <div class="righttop"></div>

        <div class="plc">
          <span>
            首页 &raquo; 走进威遥 &raquo; {{news.title}}
          </span>
        </div>
        <div class="rightbot"></div>
        <div class="righttop"></div>
        <div class="right_main">
          <div class="agent_con">
            <div class="age_li_about" id="showstate" v-html="news.nr"></div>
          </div>
          <div class="clear"></div>
        </div>

        <div class="rightbot"></div>
      </div>
      <div class="leftr">
        <div class="leib_h">
          <div class="tit" style=" text-align:center; padding:0px;">走进威遥</div>
          <div class="nr">
            <h4 v-for="item in list" :key="item.id">
              <router-link tag="a" :to="{ name: 'about', params: { id: item.id}}">{{item.title}}</router-link>
            </h4>
          </div>
        </div>
        <div class="leftbot"></div>
        <div class="leib3 mt10">
          <div class="tit">联系方式</div>
          <div class="nr">
            <div class="dianhua">
              销售热线：
              <br />
              <span>021-65056515</span>
            </div>
            <div class="dianhua">
              售后热线：
              <br />
              <span>18616336851</span>
            </div>
            <p>
              <span>公司电话：</span>021-65056515
            </p>
            <p>
              <span>公司传真：</span>021-65053165
            </p>
            <p>
              <span>公司邮箱：</span>18616336851@163.com
            </p>
            <p>
              <span>公司地址：</span>
              上海市杨浦区军工路100号20栋
            </p>
              <p>
              <span>工厂地址：</span>
              江苏省昆山市周市镇民管路25号1号楼2楼
            </p>
          </div>
          <div class="leftbot"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { getAbout } from "@/utils/api"; //引入api至当前文件
import searchC from "@/views/search";
export default {
  name: "about",
  data() {
    return {
      kimg: "",
      list: [],
      news: ""
    };
  },
  components: {
    searchC
  },
  mounted() {
    this.intPage();
  },
  watch: {
    $route() {
      this.intPage();
    }
  },
  methods: {
    intPage() {
      let id = this.$route.params.id ? this.$route.params.id : 1;
      getAbout(id).then(res => {
        this.kimg = res.about.img;
        this.news = res.about;
        this.list = res.list;
      });
    }
  }
};
</script>

<style scoped>
</style>
